module.exports = __webpack_public_path__ + "img/吴玉双.c7b7d7ae.jpg";